import { Button, IconButton, Tooltip } from "@mui/material";
import { DeleteIconButton } from "../../../assets/common-svg/CommonSvg";
import FormikControl from "../../../bmr/components/common/FormikControl";
import { FieldArray, FormikProvider } from "formik";
import { useSelector } from "react-redux";

const FormikArrayInBound = ({
  props,
  formik,
  disabledAll = false,
  handleQuestionClick = () => { },
  queriesFields = []
}) => {
  const LoginData = useSelector((state) => state.loginData);
  const {role_slug} = LoginData;
  const resolveQueryUser = ['editor','project-manager']
  const isEditor = Boolean(resolveQueryUser?.includes(role_slug));

  return (
    <FormikProvider value={formik}>
      <FieldArray name={props.name}>
        {({ push, remove }) => (
          <div
            key={props.name}
            className={
              !props.col
                ? `flex flex-col md:flex-row gap-4 items-start md:items-center`
                : `border rounded-lg shadow-sm bg-white m-2`
            }
          >
            {formik?.values[props.name]?.map((_, index) => (
              <div
                key={`arr1-${index}`}
                className={
                  props.col
                    ? `p-4 flex flex-col md:flex-row gap-4 items-start md:items-center`
                    : `flex-1 grid grid-cols-1 md:grid-cols-1 gap-4 w-full`
                }
              >
                <div
                  className={
                    props.col &&
                    `flex-1 grid grid-cols-1 md:grid-cols-${props.col} ${props.col === 2 ? "!md:grid-cols-2" : ""
                    } gap-4 w-full`
                  }
                >
                  {props
                    ?.children(index)
                    ?.map((subFieldProps, subFieldPropsIndex) => {
                      const questionInfo = queriesFields?.find(
                        (op) => op.fields?.field_name === subFieldProps.name
                      );

                      return (
                        <div
                          key={`${subFieldPropsIndex}-sub-array`}
                          className="w-full relative"
                        >
                          <FormikControl
                            formik={formik}
                            {...subFieldProps}
                            disabled={
                               questionInfo?.resolve == 0  ? false : subFieldProps.disabled}
                          />
                          {!subFieldProps.noQuery &&
                             
                            (subFieldProps.disabled || disabledAll) && (
                              <i
                                onClick={(e) =>
                                  handleQuestionClick(
                                    e,
                                    subFieldProps,
                                    questionInfo
                                  )
                                }
                                style={
                                  questionInfo?.resolve == 0
                                    ? { color: "red" }
                                    : {}
                                }
                                className="fas fa-question-circle circle-icon cursor-pointer z-50 absolute top-[0.3rem] right-2"
                                aria-hidden="true"
                              />
                            )}
                        </div>
                      );
                    })}
                </div>
                {!props.hideDeleteIcon && props.multipleField && (
                  <div
                    className={
                      disabledAll || formik.values[props.name].length == 1
                        ? " self-end md:self-center mt-3 disable-add-visit-btn"
                        : " self-end md:self-center mt-3"
                    }
                  >
                    <Tooltip title="Delete">
                      <span>
                        <IconButton
                          onClick={() => {
                            disabledAll || formik.values[props.name].length == 1
                              ? ""
                              : remove(index);
                          }}
                        >
                          <DeleteIconButton bgColor={"#FA5151"} />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </div>
                )}
              </div>
            ))}
            {!props.hideAddIcon && props.multipleField && !disabledAll && isEditor && (
              <div className="text-end m-2">
                <Button
                  type="button"
                  disabled={disabledAll}
                  // variant="contained"
                  onClick={() => push(props.initialChildrenData || {})}
                  className="mt-4"
                  fullWidth
                >
                  Add
                </Button>
              </div>
            )}
          </div>
        )}
      </FieldArray>
    </FormikProvider>
  );
};

export default FormikArrayInBound;
